import React from "react";
import PropTypes from "prop-types";
import {
  StyledStatusBar,
  StatusSquare,
  StatusIcon,
  SquareInfo,
  Qty,
  Status
} from "./styles";
import {
  FEED_STATUSES,
  FEED_STATUSES_AS_TEXT,
  FEED_STATUSES_AS_COLOR,
  selectIconByStatus
} from "../../../constants";
import { selectFeedsByStatus } from "../../../selectors";

const StatusBar = ({ activeSquare, onChangeSquare, feeds }) => (
  <StyledStatusBar>
    {FEED_STATUSES.map(status => (
      <StatusSquare
        key={status}
        id={status}
        active={activeSquare === status}
        onClick={() => onChangeSquare(status)}
      >
        <StatusIcon>{selectIconByStatus(status)}</StatusIcon>
        <SquareInfo>
          <Qty color={FEED_STATUSES_AS_COLOR[status]}>
            {selectFeedsByStatus(feeds, status).length}
          </Qty>
          <Status>{FEED_STATUSES_AS_TEXT[status]}</Status>
        </SquareInfo>
      </StatusSquare>
    ))}
  </StyledStatusBar>
);

StatusBar.propTypes = {
  activeSquare: PropTypes.string,
  onChangeSquare: PropTypes.func,
  feeds: PropTypes.arrayOf(
    PropTypes.shape({
      client: PropTypes.string,
      name: PropTypes.string,
      type: PropTypes.string,
      start: PropTypes.string,
      end: PropTypes.string,
      impressions: PropTypes.number,
      devices: PropTypes.number,
      networks: PropTypes.string,
      airings: PropTypes.number,
      brands: PropTypes.string,
      status: PropTypes.string
    })
  )
};

export default StatusBar;
